import { render, staticRenderFns } from "./form_checkbox.vue?vue&type=template&id=4bbd613c"
import script from "./form_checkbox.vue?vue&type=script&lang=js"
export * from "./form_checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports